import * as Yup from 'yup';

export const validationSchema = Yup.object({
  insurance_carrier: Yup.string().required('Insurance Carrier is required'),
  another_plan: Yup.string(),
});
